export default {
    'delete-message-attendance': 'Are you sure you want to delete this time record?'
};
